/**
 * @format
 */

//+ will conert it into a number which is required for showing active tab with MUI Tabs
export const getActiveWorkspacePositionId = key => +localStorage.getItem(key);
